import { type SxProps, type Theme } from '@mui/system';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

export const headerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  padding: '0px 8px 0px 8px',
  '& button': {
    width: '125px',
    height: '35px',
  },
  '& button > span > i': {
    fontSize: '17px !important',
  },
};

export const contentHeading: SxProps<Theme> = {
  color: '#006EC2',
  fontWeight: 'bold',
  fontSize: '28px',
  paddingTop: '20px',
  paddingBottom: '20px',
};

export const cardStyles: SxProps<Theme> = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  border: 'none',
  '& .cardTitle': {
    margin: '0px 0px 14px 0px',
    fontSize: '17px',
    color: '#006EC2',
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  '& .cardContent': {
    color: '#707070',
    margin: '20px 0px 4px 0px',
    fontSize: '17px',
  },
  '& .timeText': {
    color: '#707070',
    fontSize: '17px',
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  '& .cardContent1': {
    color: '#707070',
    margin: '20px 0px 4px 0px',
    fontSize: '17px',
  },
};

// Card
export const courseCard: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  borderLeft: '2px solid #006EC2',
  boxShadow: '0px 3px 6px #00000029',
  // padding: '10px',
};

export const cardSection1: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px',
  '& img': {
    height: '154px',
    width: '100%',
    objectFit: 'cover',
  },
};

export const cardSection2: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  '& .card-section2-main': {
    display: 'flex',
    alignItems: 'center',
    '& button': {
      fontSize: '9px',
      boxShadow: 'none',
      borderRadius: '0px',
      padding: '0px 10px 0px 10px',
      textAlign: 'center',
    },
  },
  '& .card-section2-h': {
    color: '#006EC2',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    fontSize: '24px',
  },
  '& .badge': {
    marginLeft: '20px',
    color: '#fff',
    background: '#006EC2',
    fontSize: '14px',
    padding: '2px',
  },
  '& .card-section2-desc': {
    fontSize: '18px',
    margin: '0px',
    color: '#006EC2',
  },
  '& .course-description': {
    color: '#000000',
    marginTop: '7px',
    wordBreak: 'break-word',
    fontSize: '18px',
  },
};

export const cardSectionMain: SxProps<Theme> = {
  paddingTop: '27px !important',
  paddingRight: '16px',
  [theme.breakpoints.down('md')]: {
    paddingTop: '0px !important',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '20px',
  },
};
